import { createStore, applyMiddleware } from 'redux'
import { batching } from 'redux-batch-middleware'
import reducers from 'aria-viewer/core/reducers'
import { isProduction } from 'aria-viewer/utils/environment'

export const configureStore = middleWares => {
    const createStoreWithMiddleware = applyMiddleware(...middleWares)(createStore)

    return isProduction()
        ? createStoreWithMiddleware(batching(reducers))
        : createStoreWithMiddleware(
              batching(reducers),
              window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : undefined
          )
}
